import React from "react";
import { SourceEnrollmentContainer } from "../../../containers";

const SourceEnrollment = (props) => {
  return <SourceEnrollmentContainer {...props} />;
};

export default SourceEnrollment;
